import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../components/light/Breadcrumb";
import { Content } from "../../../components/light/Content";
import { LoginLessOrderApproved } from "./list/LoginLessOrderApproved";
import { LoginLessOrderPanding } from "./list/LoginLessOrderPending";
import { LoginLessOrderRejected } from "./list/LoginLessOrderRejected";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "applications", to: "#" },
  { text: "orders", to: "#" },
  { text: "orders loginless", to: "/orders/loginless" },
];

export function LoginLessListScreen() {
  const [index, setIndex] = useState(0);
  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-6">
          <h4 className='mb-4'>Loginless Order</h4>
          <Link to="/orders/loginless/create" className="mb-4 btn btn-sm btn-secondary">Create new loginless order</Link>
          <ul className="nav nav-tabs smaller">
            <li className="nav-item">
              <Link to="#" className={`nav-link ${index === 0 ? 'active': ''}`} onClick={()=>setIndex(0)}>Pending</Link>
            </li>
            <li className="nav-item">
              <Link to="#" className={`nav-link ${index === 1 ? 'active': ''}`} onClick={()=>setIndex(1)}>Approved</Link>
            </li>
            <li className="nav-item">
              <Link to="#" className={`nav-link ${index === 2 ? 'active': ''}`} onClick={()=>setIndex(2)}>Rejected</Link>
            </li>
          </ul>
          { index === 0 && <LoginLessOrderPanding /> }
          { index === 1 && <LoginLessOrderApproved /> }
          { index === 2 && <LoginLessOrderRejected /> }
        </div>
      </div>
    </Content>
  );
}
